import { AutocompleteOption } from './types';

export const isOptionSelected = (
  selectedOption: AutocompleteOption['id'] | AutocompleteOption['name'] | AutocompleteOption | null | undefined,
  option: AutocompleteOption,
): boolean => {
  return [option, option.id, option.name].includes(selectedOption);
};
